document.addEventListener('turbo:load', initPermissionsSearch)
document.addEventListener('DOMContentLoaded', initPermissionsSearch)

function initPermissionsSearch () {
  const searchInput = document.getElementById('template-search')
  if (!searchInput) return

  searchInput.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') e.preventDefault()
  })

  searchInput.addEventListener('input', function () {
    const q = this.value.toLowerCase()
    document.querySelectorAll('.permission-row').forEach(function (row) {
      const name = row.querySelector('label') ? row.querySelector('label').textContent.toLowerCase() : ''
      row.style.display = name.includes(q) ? '' : 'none'
    })
  })
}
